import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useLocation } from "react-router-dom";
import { Music2, Pause } from "lucide-react";

export default function MusicButton() {
  const location = useLocation();
  const audio = useRef(null);
  const [available, setAvailable] = useState(false);
  const [playing, setPlaying] = useState(false);
  useEffect(() => {
    const a = new Audio("/audio/dorothee-music.mp3");
    a.loop = true; a.volume = 0.12; a.preload = "metadata"; audio.current = a;
    const loaded = () => setAvailable(true);
    const play = () => setPlaying(true);
    const pause = () => setPlaying(false);
    const duck = e => { a.volume = e.detail.busy ? 0.025 : 0.12; };
    a.addEventListener("loadedmetadata", loaded);
    a.addEventListener("play", play); a.addEventListener("pause", pause);
    window.addEventListener("dl-voice-state", duck);
    return () => {
      a.pause(); a.removeAttribute("src"); a.load();
      a.removeEventListener("loadedmetadata", loaded); a.removeEventListener("play", play); a.removeEventListener("pause", pause);
      window.removeEventListener("dl-voice-state", duck);
    };
  }, []);
  const toggle = async () => {
    const a = audio.current;
    if (!a || !available) return;
    if (!a.paused) a.pause(); else { try { await a.play(); } catch { setPlaying(false); } }
  };
  // The component remains mounted on navigation, preserving pause and position.
  if (!available || location.pathname !== "/") return null;
  return createPortal(<><style>{`button.dl-music-toggle{position:fixed;left:24px;bottom:24px;z-index:90;flex:0 0 auto;width:auto;min-width:0;min-height:44px;height:auto;display:inline-flex;align-items:center;justify-content:center;gap:8px;padding:8px 13px;border-radius:999px;color:#F3E9D2;border:1px solid #C6A76A;background:#141A2E;font-size:12px;font-weight:600;line-height:1.25;white-space:nowrap;flex-shrink:0;box-shadow:0 0 9px rgba(212,185,120,.22);animation:dlMusicGentleGlow 3.2s ease-in-out infinite}button.dl-music-toggle svg{flex-shrink:0}button.dl-music-toggle.is-playing{animation:none}button.dl-music-toggle:focus-visible{outline:2px solid #F3E9D2;outline-offset:4px}@keyframes dlMusicGentleGlow{0%,100%{box-shadow:0 0 6px rgba(212,185,120,.16)}50%{box-shadow:0 0 17px rgba(212,185,120,.5)}}@media(prefers-reduced-motion:reduce){button.dl-music-toggle{animation:none}}@media(max-width:420px){button.dl-music-toggle{font-size:11px;padding:8px 9px;gap:6px}}`}</style><button type="button" data-testid="music-toggle" onClick={toggle} className={`dl-music-toggle ${playing ? "is-playing" : ""}`} aria-label={playing ? "Mettre la musique en pause" : "Écouter la musique"} aria-pressed={playing} title={playing ? "Pause musique" : "Écouter la musique"}>
    {playing ? <Pause size={17} aria-hidden="true" /> : <Music2 size={17} aria-hidden="true" />}
  <span>{playing ? "Musique · Pause" : "Musique à écouter"}</span>
  </button></>, document.body);
}
